import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionContent: {
    borderLeft: `2px solid ${theme.palette.grey[500]}`,
    padding: '0px 8px',
    width: '100%'
  },
  titleColor: {
    color: theme.palette.grey[500]
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'rotate(90deg)',
    padding: 0,
    marginLeft: -8
  }
}))

export default useStyles
